import { CalendarDays, Scale, UtensilsCrossed, Users } from "lucide-react";
import { EXPLANATION, HIGHLIGHTS, IMAGES } from "../../lib/content";
import { Reveal } from "./Reveal";

const ICONS = [
  { Icon: CalendarDays, tone: "bg-[#C85A32] text-[#FDFBF7]" },
  { Icon: Scale, tone: "bg-[#6E8576] text-[#FDFBF7]" },
  { Icon: UtensilsCrossed, tone: "bg-[#D9A05B] text-[#2C221E]" },
  { Icon: Users, tone: "bg-[#2C221E] text-[#F2C98F]" },
];

const Collage = () => (
  <div className="relative grid grid-cols-6 grid-rows-6 gap-4 h-[420px] sm:h-[520px]">
    <div className="photo-frame col-span-6 sm:col-span-5 row-span-4">
      <img src={IMAGES.familyDinner.src} alt={IMAGES.familyDinner.alt} loading="lazy" className="h-full w-full object-cover" />
    </div>
    <div className="photo-frame col-span-3 row-span-2 sm:-mt-10 sm:ml-6 ring-8 ring-[#F7F2E9]">
      <img src={IMAGES.dadKids.src} alt={IMAGES.dadKids.alt} loading="lazy" className="h-full w-full object-cover object-top" />
    </div>
    <div className="photo-frame col-span-3 row-span-2">
      <img src={IMAGES.cooking.src} alt={IMAGES.cooking.alt} loading="lazy" className="h-full w-full object-cover" />
    </div>
  </div>
);

export const WhatIsWoven = () => (
  <section id="what-is-woven" data-testid="what-is-woven-section" className="section bg-[#F7F2E9] grain">
    <div className="relative mx-auto max-w-7xl px-6 sm:px-10 lg:px-16 grid gap-16 lg:grid-cols-2 lg:gap-20 items-center">
      <div>
        <Reveal>
          <p className="eyebrow">What is Woven</p>
          <h2 data-testid="what-is-woven-heading" className="section-title mt-4">Woven helps you show up for all of it.</h2>
          <p data-testid="what-is-woven-explanation" className="mt-6 text-base sm:text-lg leading-relaxed text-[#5C4F4A] max-w-xl">
            {EXPLANATION}
          </p>
        </Reveal>
        <ul className="mt-12 grid gap-5 sm:grid-cols-2">
          {HIGHLIGHTS.map((text, i) => {
            const { Icon, tone } = ICONS[i];
            return (
              <Reveal as="li" key={text} delay={i * 110}>
                <div data-testid={`feature-highlight-${i + 1}`} className="warm-card h-full p-6">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-full ${tone}`}>
                    <Icon className="h-5 w-5" strokeWidth={1.75} />
                  </span>
                  <p className="mt-5 text-base font-medium leading-snug text-[#2C221E]">{text}</p>
                </div>
              </Reveal>
            );
          })}
        </ul>
      </div>
      <Reveal delay={200}>
        <Collage />
      </Reveal>
    </div>
  </section>
);
